(() => {
  const init = () => {
    document.querySelectorAll('[data-rm-mobile-buy]').forEach(bar => {
      if (bar.dataset.initialized) return;
      bar.dataset.initialized = 'true';
      const info = document.getElementById(`ProductInfo-${bar.dataset.sectionId}`);
      if (!info || !window.IntersectionObserver) return;
      const button = bar.querySelector('[data-rm-mobile-submit]');
      const size = bar.querySelector('[data-rm-mobile-size]');
      const price = bar.querySelector('[data-rm-mobile-price]');
      const smallScreen = window.matchMedia('(max-width: 749px)');
      let primary;
      let passed = false;
      let queued = false;
      const updateVisibility = () => {
        const dialogOpen = document.querySelector('dialog[open], cart-drawer.active, .product-media-modal[open], quick-add-modal[open], menu-drawer details[open], .rm-mobile-menu[open]');
        bar.hidden = !smallScreen.matches || !passed || !!dialogOpen || !primary;
        document.body.classList.toggle('rm-mobile-buy-visible', !bar.hidden);
      };
      const intersection = new IntersectionObserver(entries => {
        passed = entries[0].boundingClientRect.bottom < 0;
        updateVisibility();
      });
      const sync = () => {
        queued = false;
        const current = document.getElementById(`ProductSubmitButton-${bar.dataset.sectionId}`);
        if (current !== primary) {
          intersection.disconnect();
          primary = current;
          if (primary) intersection.observe(primary);
        }
        if (!primary) { updateVisibility(); return; }
        button.disabled = primary.disabled || primary.getAttribute('aria-disabled') === 'true';
        const label = primary.querySelector('span');
        if (label) button.querySelector('span').textContent = label.textContent.trim();
        const displayedPrice = info.querySelector('.price--on-sale .price-item--sale') || info.querySelector('.price__regular .price-item--regular');
        if (displayedPrice) price.textContent = displayedPrice.textContent.trim();
        const selections = [...info.querySelectorAll('variant-selects input:checked, variant-selects select')].map(input => input.value).filter(Boolean);
        if (selections.length) size.textContent = ` · ${selections.join(' / ')}`;
        updateVisibility();
      };
      const queueSync = () => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(sync);
      };
      button.addEventListener('click', () => {
        if (!primary || button.disabled) return;
        primary.click();
        queueSync();
      });
      new MutationObserver(queueSync).observe(info, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'] });
      new MutationObserver(updateVisibility).observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open'] });
      document.addEventListener('click', queueSync);
      smallScreen.addEventListener('change', queueSync);
      window.addEventListener('pageshow', queueSync);
      sync();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
